import React from "react";
import { Badge, Card, CardHeader } from "@opendate-app/setlist";
import { formatSessionRange } from "../../ClassesShared/classLabels";
import { attendanceBadge } from "../constants/attendanceStatus";
import { useRegistrationPageContext } from "./RegistrationPageContext";
import "../registrationPage.css";
import "../../ClassesShared/classesShared.css";

export default function SessionsCard() {
  const { registration } = useRegistrationPageContext();
  const { sessions, time_zone: timeZone } = registration.dashboard;

  return (
    <Card header={<CardHeader title="Sessions & Attendance" />}>
      {sessions.length === 0 && <div className="classes-text-secondary">This class has no sessions yet.</div>}
      <div className="d-flex flex-column classes-gap-12">
        {sessions.map((session) => {
          const badge = session.upcoming && !session.attendance_status ? { color: "gray", label: "Upcoming" } : attendanceBadge(session.attendance_status);
          return (
            <div key={session.id} data-testid="registration-session" className="registration-session-row">
              <div>
                <div className="font-weight-bold">{session.name}</div>
                <div className="small classes-text-secondary">{formatSessionRange(session.starts_at, session.ends_at, timeZone)}</div>
              </div>
              <Badge color={badge.color} size="sm" dot>{badge.label}</Badge>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
